import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './DeleteUserModal.scss';

export const rolesOptions = [
  { id: 'participant', name: 'Participante' },
  { id: 'admin', name: 'Administrador' },
  { id: 'judge', name: 'Jurado' },
  { id: 'judge_leader', name: 'Jurado Líder' },
];

export const DeleteUserModal = (props) => {
  const { isOpen, closeDeleteModal, data, action } = props;

  const nameComponent = (type, rolesOptions) => {
    let [selectedType] = rolesOptions.filter((r) => r.id == type);
    return selectedType?.name || null;
  };

  return (
    <Modal size="lg" centered show={isOpen} onHide={() => closeDeleteModal()}>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar Usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Desea eliminar el siguiente usuario:
        <br />
        <br />
        <h5 className="delete-criteria-info-modal-data">
          <span>
            <b>Usuario:</b> {data?.name} {data?.lastName}
          </span>
          <span>
            <b>Correo:</b> {data?.email}
          </span>
          <span>
            <b>Rol:</b> {nameComponent(data?.userType, rolesOptions)}
          </span>
        </h5>
        <br />
        <br />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => closeDeleteModal()}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={() => action()}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
